// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__16b4H","footer":"ModalInfo_footer__EG5hz"};